
import { useHistory, useLocation } from 'react-router-dom';

import { parseJwt } from '../services/transports';
import { getAccessToken } from '../services/authentication';
import { portals } from '../constants';
import { stakeholderManagementRoutes, managementRoutes } from '../navigation';

import { useCurrentPortal } from '.';

export const useIsVerified = () => {
  const portal = useCurrentPortal();
  const { push } = useHistory();

  const token = parseJwt(getAccessToken());
  const { pathname } = useLocation();
  const ALLOWED_PATHS = [
    managementRoutes.MANAGEMENT,
    stakeholderManagementRoutes.MANAGEMENT,
    managementRoutes.PROFILE,
    stakeholderManagementRoutes.PROFILE
  ];

  if (
    portal === portals.STAKEHOLDER_OPERATION || ALLOWED_PATHS.includes(pathname)
  ) {

    return null;
  }
  if (token?.isNewPasswordRequired !== 'True') {
    return null;
  }

  if (portal === portals.MANAGEMENT) {
    push(managementRoutes.UPDATE_PROFILE);

  } else {
    push(stakeholderManagementRoutes.UPDATE_PROFILE);

  }


  return null;
};
